import { PDFViewer } from "@react-pdf/renderer";
import { useLocation } from "react-router-dom";
import { PropertyListing } from "../types/Property";
import PDFDocument from "../components/pdf/PDFGenerator";
import { useCurrency } from "../context/CurrencyContext";
import { AppBar, Toolbar, Typography, CircularProgress, Box } from "@mui/material";
import React from "react";

const PDFPreviewPage: React.FC = () => {
  const { sellRate } = useCurrency();
  
  const convertPrice = (price: number) => {
    const newPrice = sellRate ? price / sellRate : 0;
    return `${newPrice.toLocaleString('en-US')} dólares`;
  };

  const location = useLocation();
  const property: PropertyListing = location.state?.property;

  const [isLoading, setIsLoading] = React.useState(true);

  if (!property) {
    return <div>No se encontró la propiedad.</div>;
  }

  const handleLoad = () => {
    setIsLoading(false); 
  };

  return (
    <div style={{ overflowY: 'auto' }}>
      
      <AppBar position="static" color="success">
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1, textAlign: 'center' }}>
            Vista previa del PDF
          </Typography>
        </Toolbar>
      </AppBar>

      {/* Cuerpo de la página */}
      <Box sx={{ padding: 2, display: 'flex'}}>
        {isLoading && (
          <Box display="flex" justifyContent="center" alignItems="center" height="80vh">
            <CircularProgress size={60} color="success" />
          </Box>
        )}

        {/* Mostrar el PDF en un visor */}
        <PDFViewer width="100%" height='800px'>
          <PDFDocument
            property={property}
            convertedPrice={convertPrice(property.price)}
            onLoad={handleLoad} 
          />
        </PDFViewer>
      </Box>
    </div>
  );
};

export default PDFPreviewPage;
